import router from '@/router/index';
import tool from '@/utils/tool';
import userRoutes from '@/config/route';
import {initApp} from '@guizhuan/sylowcode-components'
const modules = import.meta.glob('@/views/**/*.vue')
function loadComponent(component) {
	if (!component) {
		return
	}
	const path = `/src/views/${component}.vue`
	const path1 = `/src/views/${component}/index.vue`//两种配置方式
	if (component && modules[path]) {
		return loadView(path)
	}
	if (component && modules[path1]) {
		return loadView(path1)
	} else {

	}
}

/* @vite-ignore */
const loadView = (component) => {
	if (import.meta.env.NODE_ENV === 'development') {
		return import( /* @vite-ignore */ component)
	} else {
		return modules[component]
	}
}
// 加载动态路由
function loadingRouter() {
	let apiMenu = tool.data.get("MENU") || []
	let userInfo = tool.data.get("USER_INFO")
	let userMenu = treeFilter(userRoutes, node => {
		return node.meta.role ? node.meta.role.filter(item => userInfo.role.indexOf(item) > -1).length > 0 : true
	})
	let menu = [...userMenu, ...apiMenu]
	var menuRouter = filterAsyncRouter(menu)
	menuRouter = flatAsyncRoutes(menuRouter)
	menuRouter.forEach(item => {
		if (item.component) {
			router.addRoute("layout", item)
		}
	})
    initApp()
}
//路由扁平化
function flatAsyncRoutes(routes, breadcrumb = []) {
	let res = []
	routes.forEach(route => {
		// console.log(route)
		const tmp = {...route}
		if (tmp.children) {
			let childrenBreadcrumb = [...breadcrumb]
			childrenBreadcrumb.push(route)
			let tmpRoute = {...route}
			// console.log(tmpRoute)
			tmpRoute.meta = tmpRoute.meta || {}
			tmpRoute.meta.breadcrumb = childrenBreadcrumb
			delete tmpRoute.children
			res.push(tmpRoute)
			let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
			childrenRoutes.map(item => {
				res.push(item)
			})
		} else {
			let tmpBreadcrumb = [...breadcrumb]
			tmpBreadcrumb.push(tmp)
			tmp.meta.breadcrumb = tmpBreadcrumb
			res.push(tmp)
		}
	})
	return res
}
//转换
function filterAsyncRouter(routerMap) {
	const accessedRouters = []
	routerMap.forEach(item => {
		item.meta = item.meta ? item.meta : {};
		item.meta.component = item.component
		//处理外部链接特殊路由
		if (item.meta.type === 'iframe') {
			item.meta.url = item.path;
			item.path = `/i/${item.name}`;
		}
		//MAP转路由对象
		var route = {
			path: item.path,
			name: item.name,
			meta: item.meta,
			redirect: item.redirect,
			children: item.children ? filterAsyncRouter(item.children) : null,
			component: loadComponent(item.component)
		}
		accessedRouters.push(route)
	})
	return accessedRouters
}

//过滤树
function treeFilter(tree, func) {
	return tree.map(node => ({...node})).filter(node => {
		node.children = node.children && treeFilter(node.children, func)
		return func(node) || (node.children && node.children.length)
	})
}
export default loadingRouter